/**
 * 채팅방에서 사용자별로 색상을 할당하는 유틸리티
 */

// 사용 가능한 채팅 색상 클래스 배열 (8개)
export const CHAT_USER_COLORS = [
  'bg-chat-user1',
  'bg-chat-user2',
  'bg-chat-user3',
  'bg-chat-user4',
  'bg-chat-user5',
  'bg-chat-user6',
  'bg-chat-user7',
  'bg-chat-user8',
] as const;

/**
 * 사용자 ID를 해시하여 색상 인덱스를 반환
 * @param userId - 사용자 ID
 * @returns 0-7 사이의 색상 인덱스
 */
function hashUserId(userId: string): number {
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    const char = userId.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash) % CHAT_USER_COLORS.length;
}

/**
 * 사용자 ID에 따른 채팅 배경색 클래스를 반환
 * @param userId - 사용자 ID
 * @returns Tailwind CSS 배경색 클래스
 */
export function getUserChatColorClass(userId: string): string {
  const colorIndex = hashUserId(userId);
  return CHAT_USER_COLORS[colorIndex];
}